import React, { useCallback, useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";
import styled from "styled-components";
import {
  Container,
  EmailForm,
  Input,
  LeftContainer,
  MainBox,
  RightContainer,
} from "./Login";

function ForgotPassword() {
  const [email, setEmail] = useState("");

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!email) return;

      sendPasswordResetEmail(auth, email)
        .then(() => {
          alert("📩 Şifre sıfırlama linki e-posta adresinize gönderildi.");
        })
        .catch((err) => {
          alert("⚠️ Hata: " + err.message);
        });
    },
    [email]
  );

  return (
    <Container>
      <LeftContainer>
        <MainBox style={{ color: "white" }}>
          <h1>Parola Sıfırlama</h1>
          <h3 style={{ fontSize: "1.5rem" }}>
            Parolanızı mı unuttunuz? Yan taraftaki forma e-posta adresinizi
            yazın, ardından "Parolamı Sıfırla" butonuna tıklayın.
          </h3>
        </MainBox>
      </LeftContainer>

      <RightContainer>
        <MainBox>
          <EmailForm>
            <Input
              type="email"
              placeholder="Mail Adresinizi Giriniz"
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <button type="submit" onClick={handleSubmit}>
              Parolamı Sıfırla
            </button>
          </EmailForm>
        </MainBox>
      </RightContainer>
    </Container>
  );
}

export default ForgotPassword;
